module.exports = __webpack_public_path__ + "static/flags/ER-547c7d4b296c714eca503e8c5c142cf9.gif";